import {FetchContext} from "../context/FetchContext";
import {useContext} from "react";
import {RefreshTokenAndRetry} from "../utils/utils";
import {AuthContext} from "../context/AuthContext";
import {AxiosRequestConfig} from "axios";
import {InitiateGcsResumable, UploadGcsResumable} from "./Upload";
import {LocalAssetStore} from "./LocalAssetStore";


export const useAssetStore = () => {

    const fetchContext = useContext(FetchContext);

    const authContext = useContext(AuthContext);

    const uploadAsset = async ({projectId, projectType, inputRef, filetype, languageCode}) => {

        let response;

        const config: AxiosRequestConfig = {
            headers: { Authorization: `Bearer ${authContext.getToken()}` },
        };

        const title = inputRef.files[0].name;

        try {
            response = await fetchContext.authAxios.post('/assets/upload', {
                projectId: projectId,
                projectType: projectType,
                title: title,
                fileType: filetype,
                languageCode: languageCode,
            }, config);
        } catch (error) {
            if (error.response.status === 401) {
                await RefreshTokenAndRetry(error, authContext, fetchContext);
            }
        }

        const assetId = response.data.assetId;
        const trackId = response.data.trackId;
        const projectIdFromServer = response.data.projectId;
        const signedUrl = response.data.signedUrl;

        // Create the asset/track locally.
        await LocalAssetStore.CreateTrack({trackId, assetId, projectId: projectIdFromServer, title, file: inputRef.files[0], createTime: Date.now()})

        // Extract thumbnail locally and upload

        // Do in-browser metadata extraction (sync).

        // Async and un-awaited send small size audio extracted from file for transcription.

        // Create track locally

        // Start upload to server

        let sessionUrl;
        try {
            sessionUrl = await InitiateGcsResumable(signedUrl, inputRef.files[0]);
        } catch (e) {
            console.log("Error initializing resumable upload", e);
        }

        try {
            await UploadGcsResumable(sessionUrl, inputRef.files[0], (pct) => console.log("progress", pct.toFixed(1)), 0);
            console.log("Upload complete");
        } catch (e) {
            console.log("Error uploading: ", e);
        }

        return assetId;

    }

    return {uploadAsset}
}